// react
import { MouseEvent, ReactNode } from 'react';

// mui
import { Box, Chip, ChipProps, Grid, Typography } from '@mui/material';

// ui
import { BtnMenu, BtnMenuProps } from '../BtnMenu/BtnMenu';
import { ChipStatus, ChipStatusProps } from '../ChipStatus/ChipStatus';

// props
export interface BtnBoxProps {
	BtnMenuProps?: BtnMenuProps;
	children?: ReactNode;
	ChipProps?: ChipProps;
	ChipStatusProps?: ChipStatusProps;
	count?: number;
	isActive?: boolean;
	onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

export const BtnBox = ({
	BtnMenuProps,
	children,
	ChipProps,
	ChipStatusProps,
	count,
	isActive,
	onClick,
}: BtnBoxProps) => {
	return (
		<Box
			component="button"
			onClick={onClick}
			sx={(theme) => {
				return {
					transition: `all 200ms ease`,
					borderRadius: 2,
					padding: theme.spacing(2),
					cursor: 'pointer',
					width: '100%',
					textAlign: 'left',
					...(isActive
						? {
								backgroundColor: theme.palette.brand.blue[600],
								color: theme.palette.common.white,
							}
						: {
								backgroundColor: theme.palette.brand.grey[100],
								'&:hover': {
									backgroundColor: theme.palette.brand.grey[200],
								},
							}),
				};
			}}>
			<Grid alignItems="center" container justifyContent="space-between" spacing={2}>
				<Grid item xs={true}>
					<Grid alignItems="center" container spacing={1}>
						{typeof count === 'number' && (
							<Grid item>
								<Box
									className="count"
									sx={(theme) => {
										return {
											backgroundColor: theme.palette.common.white,
											borderColor: theme.palette.divider,
											borderStyle: 'solid',
											borderWidth: 1,
											borderRadius: '50%',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											width: 30,
											height: 30,
											...(isActive && {
												backgroundColor: theme.palette.brand.blue[800],
												borderColor: theme.palette.brand.blue[800],
											}),
										};
									}}>
									<Typography fontWeight={600}>{count}</Typography>
								</Box>
							</Grid>
						)}
						<Grid item flex={1} sx={{ minWidth: 0 }}>
							{typeof children === 'string' ? (
								<Typography fontWeight={600}>{children}</Typography>
							) : (
								children
							)}
						</Grid>
					</Grid>
				</Grid>
				{(BtnMenuProps || ChipProps) && (
					<Grid item xs="auto">
						<Grid alignItems="center" container spacing={1}>
							{ChipProps && (
								<Grid item xs="auto">
									<Chip {...ChipProps} />
								</Grid>
							)}
							{ChipStatusProps && (
								<Grid item xs="auto">
									<ChipStatus {...ChipStatusProps} />
								</Grid>
							)}
							{BtnMenuProps && (
								<Grid item xs="auto">
									<BtnMenu {...BtnMenuProps} />
								</Grid>
							)}
						</Grid>
					</Grid>
				)}
			</Grid>
		</Box>
	);
};
